import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const SUPPORT_REPLY_TIME_KEY = 'support.replyTimeDisplay';
export const SUPPORT_REPLY_TIME_BOUNDS = {
    windowDays: { min: 1, max: 90 },
    minSamples: { min: 1, max: 1_000 },
    bucketSeconds: { min: 1, max: 3_600 },
};
export const DEFAULT_SUPPORT_REPLY_TIME = { windowDays: 14, minSamples: 20, bucketSeconds: 60 };
/** An unreadable version: the most demanding sample count, so no number is shown. */
export const STRICT_SUPPORT_REPLY_TIME = {
    windowDays: SUPPORT_REPLY_TIME_BOUNDS.windowDays.min,
    minSamples: SUPPORT_REPLY_TIME_BOUNDS.minSamples.max,
    bucketSeconds: DEFAULT_SUPPORT_REPLY_TIME.bucketSeconds,
};
export const SUPPORT_REPLY_TIME_POLICY_REASON_CODES = ['SUPPORT_REPLY_TIME_POLICY_GOVERNED', 'SUPPORT_REPLY_TIME_POLICY_DEFAULT', 'SUPPORT_REPLY_TIME_POLICY_INVALID'];
/** The stable issue of a value that is not a `support.replyTimeDisplay` value, or undefined when it is one. */
export function supportReplyTimeIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['windowDays', 'minSamples', 'bucketSeconds']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = SUPPORT_REPLY_TIME_BOUNDS;
    if (!intWithin(v.windowDays, b.windowDays.min, b.windowDays.max))
        return 'INVALID_WINDOW_DAYS';
    if (!intWithin(v.minSamples, b.minSamples.min, b.minSamples.max))
        return 'INVALID_MIN_SAMPLES';
    if (!intWithin(v.bucketSeconds, b.bucketSeconds.min, b.bucketSeconds.max))
        return 'INVALID_BUCKET_SECONDS';
    return undefined;
}
export const SUPPORT_REPLY_TIME_SPEC = {
    key: SUPPORT_REPLY_TIME_KEY,
    issue: supportReplyTimeIssue,
    copy: (v) => ({ windowDays: v.windowDays, minSamples: v.minSamples, bucketSeconds: v.bucketSeconds }),
    defaultValue: DEFAULT_SUPPORT_REPLY_TIME,
    strictValue: STRICT_SUPPORT_REPLY_TIME,
    reasonPrefix: 'SUPPORT_REPLY_TIME_POLICY',
};
export function supportReplyTimeSetting(input) {
    return marketRuleSetting(SUPPORT_REPLY_TIME_SPEC, input);
}
export function resolveSupportReplyTime(settings, marketId, at, regionCode) {
    return resolveMarketRule(SUPPORT_REPLY_TIME_SPEC, settings, marketId, at, regionCode);
}
//# sourceMappingURL=support-reply-time-policy.js.map